import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { ElvyraFAB } from '../elvyra/elvyra-fab';

export function DashboardLayout() {
  return (
    <div className="flex min-h-screen">
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <Sidebar />
      <main id="main-content" tabIndex={-1} className="ml-60 flex-1 min-w-0 transition-[margin-left] duration-200 outline-none" role="main">
        <div className="px-10 py-8 max-w-[1200px] mx-auto">
          <Outlet />
        </div>
      </main>
      <ElvyraFAB />
    </div>
  );
}
